import { makeResetMutation } from '@utils/reset-store'
import { buildInitialState } from './state'
const SET_PORTFOLIOS = (state, { id_cliente, portfolios = [] } = {}) => {
  if (!id_cliente) {
    return
  }

  if (!state.dados[id_cliente]) {
    state.dados[id_cliente] = {}
  }
  state.dados[id_cliente].portfolios = portfolios
}

export { SET_PORTFOLIOS }

// RESET: restaura o state inicial (libera dados de cliente/escritório retidos
// entre trocas de perfil/escritório in-SPA). Reatribui cada chave a partir do
// factory — reusa a reatividade existente. [CU-86ajnmt4r]
export const RESET = makeResetMutation(buildInitialState)
